import Button from "devextreme-react/button";
import ContextMenu, { Position } from "devextreme-react/context-menu";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { QuoteStatus, QuoteTypes } from "../../../../types/enums";
import { EstimateContext } from "../context/EstimateContext";

export default function CreateRevisionButton() {

	const { order } = useContext(EstimateContext);
	const navigate = useNavigate();

	const EE2_MENU_TEXT = 'Easy Estimator 2.0';
	const EEPRO_MENU_TEXT = 'EE Pro Tool';

	const menuItems = []
	if (!!order.details.easyEstimatorUrl) {
		menuItems.push({ text: EE2_MENU_TEXT, icon: 'Inscyth-Easy-Estimator', value: 'EE2' });
	};

	menuItems.push({ text: EEPRO_MENU_TEXT, icon: 'Inscyth-EEPro', value: 'EEPro' });

	return (
		<>
			<Button
				id="create-revision-button"
				visible={order.details.imeStatus !== 'SALE' && order.details.statusID === QuoteStatus.Open &&
					(order.details.quoteTypeID === QuoteTypes.EasyEstimator2 || order.details.quoteTypeID === QuoteTypes.EEPro || order.details.quoteTypeID === QuoteTypes.WinApp)}
			>
				<i className="dx-icon dx-icon-Inscyth-Easy-Estimator"></i>
				Create Revision
				<i className={'dx-icon dx-icon-chevrondown'}></i>
			</Button>
			<ContextMenu
				width={165}
				items={menuItems}
				target="#create-revision-button"
				showEvent="click"
				onItemClick={(e) => {
					if (order.details.quoteTypeID === QuoteTypes.WinApp) {
						alert("Estimate was edited by Sage Support team and can no longer be accessed through the estimator tools");

					}
					else {
						if (e.itemData?.text === EE2_MENU_TEXT) {
							window.open(order.details.easyEstimatorUrl + '?loadEstimate=' + order.details.guid);
						}
						else {
							navigate('/cfi/easy-estimator/' + order.details.quoteID);
						}
					}
				}}
			>
				<Position my='left top' at='left bottom'>
				</Position>
			</ContextMenu>
		</>
	)
}
